export const getClassForStatus = (status: GQL.IExternalOrderState | null) => {
    if (status == undefined) {
        return '';
    }

    switch (status.type) {
        case 'warning':
            return 'text-processing';
        case 'info':
            return 'text-success';
        case 'danger':
            return 'text-failure';
        default:
            return '';
    }
};



// WEBPACK FOOTER //
// ./src/helpers/orders/getClassForStatus.ts